import { event } from 'shared/experiments/utils/event'

export const FLYOUT_BANNER_CLICK = event`Own-brand advertising flyout banner clicked`
export const FLYOUT_BANNER_CLOSE_BUTTON_CLICK = event`Own-brand advertising flyout banner closed`
export const OWN_BRAND_PRODUCT_ADDTOCART = event`Own-brand product added to cart`
